import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Search } from "lucide-react";

export default function Transporters() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", contact_person: "", mobile: "", email: "", tracking_url: "", gst_number: "", type: "ARC" });

  const load = async () => { const { data } = await api.get("/transporters"); setItems(data); };
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post("/transporters", form); toast.success("Transporter added");
      setOpen(false); setForm({ ...form, name: "", contact_person: "", mobile: "", email: "" });
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div data-testid="page-transporters" className="space-y-5">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500">Master</div>
          <h1 className="font-heading text-3xl font-extrabold text-slate-900 mt-1">Transporters</h1>
        </div>
        <button data-testid="btn-new-transporter" onClick={() => setOpen(true)} className="bg-[var(--navy)] hover:bg-slate-800 text-white text-sm font-semibold px-4 py-2.5 rounded-md flex items-center gap-2">
          <Plus size={16} /> New Transporter
        </button>
      </div>

      <div className="flex items-center gap-2 bg-white border border-slate-200 rounded-md px-3 py-2 max-w-xl">
        <Search size={14} className="text-slate-400" />
        <input
          data-testid="input-transporter-search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search code, name, contact, mobile, GST, type…"
          className="flex-1 outline-none text-sm bg-transparent"
        />
        {q && <button onClick={() => setQ("")} className="text-xs text-slate-500 hover:text-slate-700">Clear</button>}
      </div>

      <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50">
            <tr className="text-[11px] font-semibold uppercase tracking-widest text-slate-500 text-left">
              <th className="px-5 py-3">Code</th><th className="px-5 py-3">Name</th><th className="px-5 py-3">Contact</th>
              <th className="px-5 py-3">Mobile</th><th className="px-5 py-3">GST</th><th className="px-5 py-3">Type</th>
            </tr>
          </thead>
          <tbody>
            {(() => {
              const qq = q.trim().toLowerCase();
              const visible = qq
                ? items.filter((t) => [t.code, t.name, t.contact_person, t.mobile, t.email, t.gst_number, t.type]
                    .filter(Boolean).some((v) => String(v).toLowerCase().includes(qq)))
                : items;
              return (<>
              {visible.map((t) => (
                <tr key={t.id} className="table-row border-t border-slate-100">
                  <td className="px-5 py-3 font-mono text-xs">{t.code}</td>
                  <td className="px-5 py-3 font-medium">{t.name}</td>
                  <td className="px-5 py-3 text-slate-600">{t.contact_person || "-"}</td>
                  <td className="px-5 py-3 text-slate-600 font-mono text-xs">{t.mobile || "-"}</td>
                  <td className="px-5 py-3 text-slate-600">{t.gst_number || "-"}</td>
                  <td className="px-5 py-3"><span className="text-xs px-2 py-1 rounded-full bg-slate-100">{t.type}</span></td>
                </tr>
              ))}
              {visible.length === 0 && <tr><td colSpan="6" className="py-8 text-center text-slate-500">{q ? `No matches for "${q}"` : "No transporters yet"}</td></tr>}
              </>);
            })()}
          </tbody>
        </table>
      </div>

      {open && (
        <div className="fixed inset-0 bg-slate-900/40 flex items-center justify-center z-40" onClick={() => setOpen(false)}>
          <form onSubmit={save} onClick={(e) => e.stopPropagation()} className="bg-white rounded-lg p-6 w-full max-w-lg" data-testid="dialog-new-transporter">
            <h2 className="font-heading text-xl font-bold mb-4">New Transporter</h2>
            <div className="grid grid-cols-2 gap-3">
              {[["name", "Transporter Name*", true], ["contact_person", "Contact Person"], ["mobile", "Mobile"], ["email", "Email"], ["gst_number", "GST Number"], ["tracking_url", "Tracking URL"]].map(([k, l, req]) => (
                <div key={k} className={k === "name" ? "col-span-2" : ""}>
                  <label className="text-[11px] uppercase font-semibold tracking-widest text-slate-500">{l}</label>
                  <input data-testid={`tr-${k}`} required={req} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="w-full mt-1 px-3 py-2 border border-slate-300 rounded-md text-sm" />
                </div>
              ))}
              <div>
                <label className="text-[11px] uppercase font-semibold tracking-widest text-slate-500">Type</label>
                <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} className="w-full mt-1 px-3 py-2 border border-slate-300 rounded-md text-sm">
                  <option>ARC</option><option>Non-ARC</option>
                </select>
              </div>
            </div>
            <div className="flex justify-end gap-2 mt-5">
              <button type="button" onClick={() => setOpen(false)} className="px-4 py-2 text-sm border border-slate-300 rounded-md">Cancel</button>
              <button data-testid="btn-save-transporter" className="px-4 py-2 text-sm bg-[var(--navy)] text-white rounded-md">Create</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
